<template>
    <div class="noticedetails">
        <div class="noticedetails_title">{{noticeDatails.title}}</div>
        <div class="noticedetails_msg">
            <div>类型：{{noticeDatails.typeName}}</div>
            <div>发布人：{{noticeDatails.publishPeople}}</div>
            <div>发布时间：{{noticeDatails.inputTime}}</div>
        </div>
        <div class="noticedetails_content" v-html="noticeDatails.content"></div>
    </div>
</template>

<script>
import { queryNoticeDetail } from "@/api/manageCenter";
export default {
    name: "noticeDetails",
    data() {
        return {
            id: sessionStorage.getItem("noticeId"), //公告id
            noticeDatails: {}, //公告详情
        };
    },
    methods: {
        getNoticeDetail() {
            let params = { id: this.id };
            this.$post(queryNoticeDetail, params).then((res) => {
                if (res.success) {
                    this.noticeDatails = res.data;
                } else {
                    this.$confirm(`${res.msg}`, "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        showCancelButton: false,
                        center: true,
                        type: "warning",
                    })
                        .then(() => {
                            this.$router.push("/messageManage");
                            this.$store.commit("delete_tabs", "/noticeDetails");
                        })
                        .catch(() => {
                            this.$router.push("/messageManage");
                            this.$store.commit("delete_tabs", "/noticeDetails");
                        });
                }
            });
        },
    },
    mounted() {
        this.getNoticeDetail();
    },
};
</script>

<style scoped lang="less">
.noticedetails {
    background: #ffffff;
    padding: 50px 50px 60px 50px;
    min-height: 750px;
    margin: 10px 0 0 10px;
    &_title {
        font-size: 22px;
        font-weight: bold;
        text-align: center;
        line-height: 1.5;
        width: 80%;
        margin: 0 auto;
    }
    &_msg {
        display: flex;
        justify-content: center;
        color: #999999;
        margin: 20px 0 38px 0;
        font-size: 14px;
        > div {
            padding-right: 15px;
        }
    }
    &_content {
        line-height: 2;
        color: #666666 !important;
        font-size: 16px !important;
    }
}
</style>